
export default function getUrlKey(k) {
    const url = window.location.href
    const encode = new RegExp('[?|&]' + k + '=' + '([^&;]+?)(&|#|;|$)').exec(url) || [, ""]
    return decodeURIComponent((encode)[1].replace(/\+/g, '%20')) || '';
}
